import React from 'react'
import PropTypes from 'prop-types'
import { PrimaryButton } from '@aok/ui-elements'
import Icon from '@aok/icon-functional'

import defaultProps from '../../../utils/propTypes/defaultProps'

const DataSecurity = ({ icon, text, onClick }) => {
  return (
    <div
      className="
        relative bg-e8f4f2
        flex flex-col justify-center items-center
        py-48 px-16 600:py-64 720:px-24 1000:px-0
        840:grid 840:grid-cols-8 840:gap-x-24 1000:gap-x-32
      "
    >
      {icon && (
        <div className="840:col-start-2 840:col-end-8 flex justify-center">
          <Icon name={icon} className="fill-current text-005e3f w-32 h-32" />
        </div>
      )}

      <div
        dangerouslySetInnerHTML={{ __html: text }}
        className="textBlock text-center mt-16 840:col-start-2 840:col-end-8"
      />

      <div className="mt-24 600:mt-32 840:col-start-2 840:col-end-8 flex justify-center">
        <PrimaryButton onClick={onClick}>Inhalt anzeigen</PrimaryButton>
      </div>
    </div>
  )
}

DataSecurity.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
}

DataSecurity.defaultProps = {
  text: defaultProps.TEXT,
  onClick: () => {},
}

export default DataSecurity
